import { el, mount, unmount } from 'redom';

import { displayElementAroundAnchor } from 'utilities/element-position';

import { stringToSVG } from 'utilities';

import './index.scss';

import fitControlsIconString from 'assets/images/image-fit-icon.svg?raw';
import coverIconString from 'assets/images/image-fit-cover-icon.svg?raw';
import containIconString from 'assets/images/image-fit-contain-icon.svg?raw';

const fitControlsIcon = stringToSVG(fitControlsIconString);
const coverIcon = stringToSVG(coverIconString);
const containIcon = stringToSVG(containIconString);

export const fitTypes = {
  COVER: 'cover',
  CONTAIN: 'contain'
};

class FitControls {

  constructor(configuration) {

    this.fit = configuration.fit;
    this.onChange = configuration.onChange;
    this.hideTimeout = null;

    this.coverControl = null;
    this.containControl = null;

    this.list = el('.fit-controls', {}, [
      this.renderCoverControl(),
      this.renderContainControl()
    ]);

    this.button = this.renderButton();

    this.el = el('.fit-controls-main', {
      onmouseenter: this.handleMouseEnter.bind(this),
      onmouseleave: this.handleMouseLeave.bind(this)
    }, [
      this.button
    ]);

    this.applyState();

  }

  handleMouseEnter() {

    if (this.hideTimeout !== null) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }

    mount(this.el, this.list);

    const element = this.list;
    const anchorElement = this.button;
    const viewportElement = void 0;
    const verticalOffset = 7;
    const horizontalOffset = 0;
    const startSide = 'top';
    const placeOnCenter = true;
    const positionableSides = ['top', 'bottom'];

    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);

  }

  handleMouseLeave() {

    this.hideTimeout = setTimeout(function delayedHide() {
      unmount(this.el, this.list);
      this.hideTimeout = null;
    }.bind(this), 350);

  }

  renderButton() {

    const options = {};

    if (typeof this.fit === 'string') {
      options.class = 'active';
    }

    return el('button.fit-control', options, fitControlsIcon.cloneNode(true));

  }

  renderCoverControl() {

    this.coverControl = el('button', {
      class: 'fit-control',
      onclick: this.handleCoverControlClick.bind(this)
    }, coverIcon.cloneNode(true));

    return el('x-tooltip', {
      text: 'Cover the area'
    }, this.coverControl);

  }

  renderContainControl() {

    this.containControl = el('button', {
      class: 'fit-control',
      onclick: this.handleContainControlClick.bind(this)
    }, containIcon.cloneNode(true));

    return el('x-tooltip', {
      text: 'Fit within the area'
    }, this.containControl);

  }

  applyState() {

    this.coverControl.classList.remove('active');
    this.containControl.classList.remove('active');

    this.button.classList.remove('active');

    if (typeof this.fit !== 'string') {
      return;
    }

    this.button.classList.add('active');

    if (this.fit === fitTypes.COVER) {
      this.coverControl.classList.add('active');
    } else {
      this.containControl.classList.add('active');
    }

  }

  select(fit) {

    if (this.fit === fit) {
      this.fit = null;
    } else {
      this.fit = fit;
    }

    this.applyState();

    this.onChange(this.fit);

  }

  handleCoverControlClick() {

    this.select(fitTypes.COVER);

  }

  handleContainControlClick() {

    this.select(fitTypes.CONTAIN);

  }

  update(configuration) {

    this.fit = configuration.fit;

    this.applyState();

  }

}

export default FitControls;
